/* eslint-disable react/prop-types */
import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import Chip from "@material-ui/core/Chip"; // Import Chip component
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import NavPills from "components/NavPills/NavPills.js";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import EventIcon from "@material-ui/icons/Event";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";

import { DATE_DISPLAY_FORMAT_DETAILED, dayjs } from "utils/time.jsx";

import {
  getData,
  updateData,
  updateHealthMetricsData,
  getHealthMetricsData
} from "services/userDataProvider.js";
import { getMyUsers } from "../../services/advisorUsers.js";

import { Input } from "@material-ui/core";
import { MEDIA_ROOT } from "config.js";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  infoHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    background: "hsla(0,0%,98%,.85)",
    boxShadow: "0px 0px 1px 0 hsl(0deg 0% 6% / 40%)",
    borderRadius: "20px"
  },
  updateInfo: {
    color: "blue"
  },
  aboutMeSection: {
    fontStyle: "italic",
    color: "#555",
    backgroundColor: "#f9f9f9",
    padding: "10px",
    borderRadius: "5px"
  }
};

class TraineeProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedData: {},
      userHealthMetrics: {}
    };
  }

  updateProfile = e => {
    updateData(
      this.props.axios,
      this.state.selectedTrainee.id,
      this.state.updatedData
    );
  };

  updateHealthMetrics = e => {
    updateHealthMetricsData(
      this.props.axios,
      this.state.selectedTrainee.id,
      this.state.userHealthMetrics
    );
  };

  onFileLoad = e => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      let updatedData = this.state.updatedData;
      updatedData["avatarFile"] = file;
      this.setState({ updatedData: updatedData });
    }
  };

  onChange = name => e => {
    let updatedData = this.state.updatedData;
    updatedData[name] = e.target.value;
    this.setState({ [name]: e.target.value, updatedData: updatedData });
  };

  onHealthMetricChange = name => e => {
    let updatedData = this.state.userHealthMetrics || {};
    updatedData[name] = e.target.value;
    this.setState({ userHealthMetrics: updatedData });
  };

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const userName = this.props.match.params.userName;
    getMyUsers(this.props.axios).then(async users => {
      const userId = users.find(user => user.username === userName).id;
      const userData = await getData(this.props.axios, userId);
      const healthMetricsData = await getHealthMetricsData(
        this.props.axios,
        userId
      );
      this.setState({
        ...userData,
        userHealthMetrics: healthMetricsData,
        users: users,
        userId: userId,
        selectedTrainee: users.find(user => user.username === userName)
      });
    });
  }

  handleUserChange = async value => {
    const selectedUser =
      this.state.users && this.state.users.find(u => u.id === value);
    if (selectedUser) {
      this.props.history.push(`/trainee-profile/${selectedUser.username}`);
      window.location.reload();
    }
  };

  renderUsersSelectionBox() {
    let userOptions =
      this.state.users &&
      this.state.users.map(user => {
        return { text: user.username, value: user.id };
      });
    const selectedTraineeName =
      this.state.selectedTrainee && this.state.selectedTrainee.username;
    return (
      <div style={{ paddingBottom: "20px" }}>
        <CustomSelect
          labelText={selectedTraineeName || "Trainee"}
          items={userOptions}
          onChange={this.handleUserChange}
        />
      </div>
    );
  }

  renderProfileDetails() {
    const { classes } = this.props;
    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Profile details</h4>
          <p className={classes.cardCategoryWhite}>
            Update the profile details
          </p>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Username"
                id="username"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.username,
                  onChange: this.onChange("username")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Email address"
                id="email"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.email,
                  onChange: this.onChange("email")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="First Name"
                id="first_name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.first_name,
                  onChange: this.onChange("first_name")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                labelText="Last Name"
                id="last_name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.last_name,
                  onChange: this.onChange("last_name")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="City"
                id="city"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.city,
                  onChange: this.onChange("city")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="Country"
                id="country"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.country,
                  onChange: this.onChange("country")
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <CustomInput
                labelText="Postal Code"
                id="postal_code"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.postal_code,
                  onChange: this.onChange("postal_code")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <InputLabel style={{ color: "#AAAAAA" }}>About me</InputLabel>
              <CustomInput
                labelText={""}
                id="about_me"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.about_me,
                  onChange: this.onChange("about_me"),
                  multiline: true,
                  rows: 5
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <InputLabel style={{ color: "#AAAAAA" }}>Avatar</InputLabel>
              <Input type="file" onChange={this.onFileLoad} />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button color="info" onClick={this.updateProfile}>
            Update Profile
          </Button>
        </CardFooter>
      </Card>
    );
  }

  renderHealthMetrics() {
    const { classes } = this.props;
    const { userHealthMetrics } = this.state;
    const lastUpdatedTime = userHealthMetrics.updated_at;
    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Health Metrics</h4>
          <p className={classes.cardCategoryWhite}>
            Keep the health metrics updated
          </p>
          {lastUpdatedTime != null && (
            <div style={styles.updateInfo}>
              <label style={styles.updateInfoLabel}>Last update: </label>
              <large>
                {dayjs(lastUpdatedTime).format(DATE_DISPLAY_FORMAT_DETAILED)},{" "}
                {dayjs(lastUpdatedTime).fromNow()}
              </large>
            </div>
          )}
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Age"
                id="Age"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.age,
                  onChange: this.onHealthMetricChange("age")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Weight(KG)"
                id="Weight"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.weight,
                  onChange: this.onHealthMetricChange("weight")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Height(CM)"
                id="Height(CM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.height,
                  onChange: this.onHealthMetricChange("height")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="BMI"
                id="BMI"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.bmi,
                  onChange: this.onHealthMetricChange("bmi")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Resting Heart Rate(BPM)"
                id="Resting Heart Rate(BPM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.resting_heart_rate,
                  onChange: this.onHealthMetricChange("resting_heart_rate")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Max Heart Rate(BPM)"
                id="Max Heart Rate(BPM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.max_heart_rate,
                  onChange: this.onHealthMetricChange("max_heart_rate")
                }}
              />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="VO2 Max(ml/kg/min)"
                id="VO2 Max(ml/kg/min)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  disable: true,
                  value: userHealthMetrics.vo2_max,
                  onChange: this.onHealthMetricChange("vo2_max")
                }}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={3}>
              <CustomInput
                labelText="Lactate Threshold (BPM)"
                id="Lactate Threshold (BPM)"
                formControlProps={{
                  fullWidth: false
                }}
                inputProps={{
                  type: "number",
                  value: userHealthMetrics.lactate_threshold,
                  onChange: this.onHealthMetricChange("lactate_threshold")
                }}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button color="info" onClick={this.updateHealthMetrics}>
            Update
          </Button>
        </CardFooter>
      </Card>
    );
  }

  renderTraineePrs() {
    const { userHealthMetrics } = this.state;
    const personalBestEfforts =
      (userHealthMetrics &&
        userHealthMetrics.other_data &&
        userHealthMetrics.other_data.personal_best_efforts) ||
      {};
    const distances = [
      { label: "400m", key: "pr_400m", color: "#e3f2fd" },
      { label: "1 Mile", key: "pr_1mile", color: "#fce4ec" },
      { label: "5K", key: "pr_5k", color: "#e8f5e9" },
      { label: "10K", key: "pr_10k", color: "#fff3e0" },
      { label: "Half Marathon", key: "pr_half_marathon", color: "#ede7f6" },
      { label: "Marathon", key: "pr_marathon", color: "#f3e5f5" }
    ];

    return (
      <div>
        <h5>Personal Bests</h5>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "10px",
                  borderBottom: "1px solid #ddd"
                }}
              >
                Distance
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "10px",
                  borderBottom: "1px solid #ddd"
                }}
              >
                Time
              </th>
            </tr>
          </thead>
          <tbody>
            {distances.map(distance => (
              <tr
                key={distance.key}
                style={{ backgroundColor: distance.color }}
              >
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  {distance.label}
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  {personalBestEfforts[distance.key] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderPlannedRaces() {
    const { classes } = this.props;
    const { userHealthMetrics } = this.state;
    const plannedRaces =
      (userHealthMetrics &&
        userHealthMetrics.other_data &&
        userHealthMetrics.other_data.planned_races) ||
      [];

    return (
      <Card>
        <CardHeader color="info">
          <h4 className={classes.cardTitleWhite}>Planned Races</h4>
          <p className={classes.cardCategoryWhite}>
            View and manage your upcoming races
          </p>
        </CardHeader>
        <CardBody>
          {plannedRaces.length > 0 ? (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}
                  >
                    Race Name
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}
                  >
                    Distance
                  </th>
                </tr>
              </thead>
              <tbody>
                {plannedRaces.map((race, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      {race.name}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      {dayjs(race.date).format(DATE_DISPLAY_FORMAT_DETAILED)}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      {race.distance}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No planned races available.</p>
          )}
        </CardBody>
      </Card>
    );
  }

  renderRoles() {
    const { roles } = this.state;
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
        {roles &&
          roles.map((role, index) => (
            <Chip
              key={index}
              label={role}
              style={{
                backgroundColor: "#e0f7fa",
                color: "#00796b",
                fontWeight: "bold"
              }}
            />
          ))}
      </div>
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars, react/prop-types
    const { classes, user } = this.props;
    const isAdvisor = user.roles && user.roles.includes("ADVISOR");
    const availableTabs = [
      {
        tabButton: "Profile",
        tabIcon: AccountCircleIcon,
        tabContent: this.renderProfileDetails()
      },
      {
        tabButton: "Metrics",
        tabIcon: FitnessCenterIcon,
        tabContent: this.renderHealthMetrics()
      },
      {
        tabButton: "Planned Races",
        tabIcon: EventIcon, // Updated icon for Planned Races
        tabContent: this.renderPlannedRaces()
      }
    ];
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            {isAdvisor ? this.renderUsersSelectionBox() : null}
            <Card profile>
              <CardAvatar profile>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <img src={`${MEDIA_ROOT}${this.state.avatar}`} alt="..." />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h4 className={classes.cardTitle}>
                  {this.state.first_name} {this.state.last_name}
                </h4>
                <div>{this.renderRoles()}</div>
                <p
                  className={`${classes.description} ${classes.aboutMeSection}`}
                >
                  {this.state.about_me}
                </p>
                <div className={classes.traineePrs}>
                  {this.renderTraineePrs()}
                </div>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <NavPills
              color="warning"
              vertical={{
                tabsGrid: { xs: 12, sm: 12, md: 12 },
                contentGrid: { xs: 12, sm: 12, md: 12 }
              }}
              tabs={availableTabs}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(TraineeProfile);
